export default {
  name: 'zh-cn',
  z: {
    request: {
      400: '请求参数错误',
      408: '网络请求超时，请稍后重试',
      401: '未登录或登录已过期',
      403: '没有操作权限',
      404: '请求地址不存在',
      500: '服务器内部错误',
      502: '网关错误',
      503: '服务暂不可用',
      504: '服务响应超时',
    },
    breadcrumb: {
      label: '面包屑',
    },
    colorpicker: {
      confirm: '确定',
      clear: '清空',
      defaultLabel: '颜色选择器',
      description: '当前颜色 {color}，按 Enter 键选择新颜色',
      alphaLabel: '选择透明度的值',
    },
    datepicker: {
      now: '此刻',
      today: '今天',
      cancel: '取消',
      clear: '清空',
      confirm: '确定',
      dateTablePrompt: '使用方向键与 Enter 键可选择日期',
      monthTablePrompt: '使用方向键与 Enter 键可选择月份',
      yearTablePrompt: '使用方向键与 Enter 键可选择年份',
      selectedDate: '已选日期',
      selectDate: '选择日期',
      selectTime: '选择时间',
      startDate: '开始日期',
      startTime: '开始时间',
      endDate: '结束日期',
      endTime: '结束时间',
      prevYear: '前一年',
      nextYear: '后一年',
      prevMonth: '上个月',
      nextMonth: '下个月',
      year: '年',
      month1: '1 月',
      month2: '2 月',
      month3: '3 月',
      month4: '4 月',
      month5: '5 月',
      month6: '6 月',
      month7: '7 月',
      month8: '8 月',
      month9: '9 月',
      month10: '10 月',
      month11: '11 月',
      month12: '12 月',
      // week: '周次',
      weeks: {
        sun: '日',
        mon: '一',
        tue: '二',
        wed: '三',
        thu: '四',
        fri: '五',
        sat: '六',
      },
      weeksFull: {
        sun: '星期日',
        mon: '星期一',
        tue: '星期二',
        wed: '星期三',
        thu: '星期四',
        fri: '星期五',
        sat: '星期六',
      },
      months: {
        jan: '一月',
        feb: '二月',
        mar: '三月',
        apr: '四月',
        may: '五月',
        jun: '六月',
        jul: '七月',
        aug: '八月',
        sep: '九月',
        oct: '十月',
        nov: '十一月',
        dec: '十二月',
      },
    },
    inputNumber: {
      decrease: '减少数值',
      increase: '增加数值',
    },
    select: {
      loading: '加载中',
      noMatch: '无匹配数据',
      noData: '无数据',
      placeholder: '请选择',
    },
    dropdown: {
      toggleDropdown: '切换下拉选项',
    },
    mention: {
      loading: '加载中',
    },
    cascader: {
      noMatch: '无匹配数据',
      loading: '加载中',
      placeholder: '请选择',
      noData: '暂无数据',
    },
    pagination: {
      goto: '前往',
      pagesize: '条/页',
      total: '共 {total} 条',
      pageClassifier: '页',
      page: '页',
      prev: '上一页',
      next: '下一页',
      currentPage: '第 {pager} 页',
      prevPages: '向前 {pager} 页',
      nextPages: '向后 {pager} 页',
      deprecationWarning:
        '你使用了一些已被废弃的用法，请参考 z-pagination 的官方文档',
    },
    rules: {
      loading: '正在加载参数字段…',
      empty: '暂无可用参数字段',
      summaryTitle: '逻辑描述',
      summaryEmpty: '请在下方案件组中配置规则，生效后将在此显示可读描述',
      ruleName: '规则名称',
      ruleNamePlaceholder: '请输入规则名称',
      ruleNameRequired: '请输入规则名称',
      errorMessageRequired: '请输入错误消息',
      resultValueRequired: '请填写规则结果',
      ruleDescription: '规则描述',
      ruleDescriptionPlaceholder: '请输入规则描述',
      ruleDescriptionAuto: '请配置规则条件，描述将自动生成',
      ruleCondition: '规则条件',
      ruleResult: '规则结果',
      contentType: '结果类型',
      resultEmpty: '请配置 ruleResult 或使用 result 插槽',
      errorMessage: '错误消息',
      errorMessagePlaceholder: '请输入命中该规则时的错误提示',
      content: {
        error: 'error',
        boolean: 'boolean',
        result: 'result',
      },
      clear: '清空',
      saveRule: '保存规则',
      addRule: '添加规则',
      updateRule: '更新规则',
      cancelEdit: '取消编辑',
      delete: '删除',
      edit: '编辑',
      newRuleDialog: '新建规则',
      editRuleDialog: '编辑规则',
      selectRuleFirst: '请先选择一条规则',
      listEmpty: '暂无规则，请点击「新增」创建规则',
      loadFailed: '规则列表加载失败',
      saveSuccess: '保存成功',
      saveFailed: '保存失败',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败',
      colSystem: '系统',
      colRuleName: '规则名称',
      colRuleDescription: '规则描述',
      colModule: '模块',
      colRuleScript: '规则脚本',
      colEnabled: '是否开启',
      colRulesJson: '规则条件(json)',
    },
    dialog: {
      close: '关闭此对话框',
    },
    drawer: {
      close: '关闭此对话框',
    },
    messagebox: {
      title: '提示',
      confirm: '确定',
      cancel: '取消',
      error: '输入的数据不合法!',
      close: '关闭此对话框',
    },
    upload: {
      deleteTip: '按 delete 键可删除',
      delete: '删除',
      preview: '查看图片',
      continue: '继续上传',
    },
    slider: {
      defaultLabel: '滑块介于 {min} 至 {max}',
      defaultRangeStartLabel: '选择起始值',
      defaultRangeEndLabel: '选择结束值',
    },
    table: {
      operator: {
        eq: '等于',
        ne: '不等于',
        like: '包含',
        notLike: '不包含',
        gt: '大于',
        lt: '小于',
        ge: '大于等于',
        le: '小于等于',
        gte: '大于等于',
        lte: '小于等于',
        empty: '为空',
        notEmpty: '不为空',
        range: '到',
      },
      logic: {
        and: '并且',
        or: '或者',
      },
      filterTitle: '筛选器',
      addFilter: '+ 添加条件',
      addFilterGroup: '+ 添加条件组',
      removeFilterGroup: '删除条件组',
      filterGroup: '条件组',
      filterGroupInnerAnd: '组内：并且',
      filterGroupInnerOr: '组内：或者',
      filterSummary: '筛选条件',
      filterEdit: '编辑',
      toolbar: {
        add: '新增',
        copy: '浅复制',
        delete: '删除',
        save: '保存',
        cancel: '取消',
        saveAndNew: '保存并新建',
        saveAndCopy: '保存并浅复制',
        refresh: '刷新',
        clearSort: '清除排序',
        filter: '筛选器',
        search: '搜索',
        searchPlaceholder: '全局搜索',
        more: '更多',
        import: '导入',
        export: '导出',
        custom: '列设置',
      },
      aiAssistant: {
        title: 'AI 助手',
        newConversation: '新对话',
        history: '对话历史',
        close: '关闭',
        empty: '暂无提示记录',
        placeholder: '输入或说出指令…',
        suggestions: '建议',
        send: '发送',
        sending: '处理中…',
      },
      saveSuccess: '保存成功',
      saveFailed: '保存失败',
      saveNoData: '无可保存的数据',
      deleteSuccess: '删除成功',
      deleteNoSelection: '请选择删除的数据',
      deleteConfirm: '确定删除选中的记录吗？',
      deleteTitle: '提示',
      confirm: '确认',
      dragTip: '移动：{dragTip}',
      emptyText: '暂无数据',
      loadingText: '加载中...',
      loadError: '数据加载失败',
      loadErrorDetail: '请稍后重试，或联系管理员',
      loadCancel: '取消',
      loadRetry: '重新加载',
      horizontalScrollTip: 'Shift/Alt + 滚轮 横向滚动',
      contextMenu: {
        more: '更多',
      },
      columnMenu: {
        title: '单列筛选',
        sort: '排序',
        sortAsc: '升序',
        sortDesc: '降序',
        sortReset: '重置',
        data: '当前列数据',
        uniqueValues: '唯一值 {count}',
        statistics: '统计',
        copy: '复制',
        filter: '筛选',
        filterClear: '清除',
        valueList: '列数据',
        valueListSearchPlaceholder: '搜索列数据',
        valueListSearch: '搜索',
        filterSearchPlaceholder: '输入关键字筛选当前列',
        more: '更多',
        pin: '固定',
        pinLeft: '固定左侧',
        pinRight: '固定右侧',
        hide: '隐藏',
        columnManage: '列管理',
        restoreDefault: '恢复默认',
        apply: '确认',
      },
      confirmFilter: '筛选',
      resetFilter: '重置',
      clearFilter: '清除全部',
      sumText: '合计',
      allTitle: '全选/取消',
      uploadCell: {
        manage: '管理',
        upload: '上传',
        imageTitle: '管理{title}',
        fileTitle: '管理{title}',
        uploading: '正在上传，请稍候',
        uploadFailed: '尚未上传成功，请等待上传完成后再确认',
        missingUploadAction: '未配置 uploadAction，无法上传',
        batchDownload: '打包下载',
        uploadDrag: '将文件拖到此处，或点击上传',
        uploadAcceptHint: '支持格式：{accept}',
      },
      custom: {
        title: '列设置',
        all: '全部',
        allColumn: '全部列',
        columnTitle: '列标题',
        columnWidth: '列宽（像素）',
        freezeColumn: '冻结列（最多 {count} 列）',
        searchPlaceholder: '搜索列…',
        systemColumns: '系统列',
        dataColumns: '数据列',
        emptySearch: '无匹配列',
        dragTip: '可拖动',
        dragDisabledTip: '清空搜索后可拖拽排序',
        pinShort: '固定',
        pinLeft: '左侧',
        pinNone: '默认',
        pinRight: '右侧',
        pinLeftShort: '左',
        pinRightShort: '右',
        maxFixedWarning: '最多冻结 {count} 列',
        reset: '恢复默认',
        cancel: '取消',
        confirm: '确定',
      },
    },
    import: {
      impTitle: '导入数据',
      impFile: '选择文件',
      impSelect: '选取文件',
      impType: '文件类型',
      impMode: '导入方式',
      impCancel: '取消',
      impConfirm: '确认导入',
      stepSelectFile: '选择文件',
      stepSelectFileDesc: '支持 .xlsx / .xls',
      stepValidate: '校验数据',
      stepValidateDesc: '检查必填项',
      stepValidateDescServer: '预览编辑，确认后提交后端校验',
      stepResult: '导入结果',
      stepResultDesc: '查看导入汇总',
      serverValidateHint: '确认导入时由后端校验',
      pendingServerValidate: '待校验',
      serverValidateFailed: '后端校验未通过，请修正后重试',
      templateTitle: '下载导入模板',
      templateDescPrefix: '请按模板表头填写数据后上传，带',
      templateDescSuffix: '为必填列',
      templateRequired: '必填',
      downloadTemplate: '下载模板',
      uploadDrag: '将 Excel 文件拖到此处，或点击上传',
      uploadHint: '仅支持 .xlsx、.xls 格式',
      selectedFile: '已选',
      totalRows: '共 {count} 条',
      errorRows: '错误 {count} 条',
      errorListTitle: '校验错误明细',
      modeHint: '导入方式：{mode}',
      noData: '未解析到有效数据',
      rowNo: '行号',
      validateCol: '校验',
      passed: '通过',
      prevStep: '上一步',
      nextStep: '下一步',
      noImportColumns: '当前表格没有可导入的列',
      templateDownloading: '模板已开始下载',
      noExcelData: 'Excel 中未解析到有效数据，请检查表头是否与列标题一致',
      parseFailed: '文件解析失败，请检查文件格式',
      invalidExcel: '请选择 .xlsx 或 .xls 文件',
      importSuccess: '已导入 {count} 条数据',
      importResultDesc: '导入方式：{mode}，源文件：{file}',
      finish: '完成',
      fieldRequired: '{title}不能为空',
      copyRows: '复制选中行',
      deleteRows: '删除选中行',
      copyNoSelection: '请先勾选要复制的行',
      deleteNoSelection: '请先勾选要删除的行',
      deleteConfirm: '确定删除选中的 {count} 行吗？',
      deleteTitle: '提示',
      deleteConfirmBtn: '确认',
      deleteCancelBtn: '取消',
      copySuccess: '已复制 {count} 行',
      deleteSuccess: '已删除 {count} 行',
      maxRowsReached: '单次最多导入 {count} 行',
      modes: {
        insertTop: '顶部追加',
        covering: '覆盖当前页数据',
      },
    },
    export: {
      expTitle: '导出数据',
      printTitle: '打印数据',
      expName: '文件名',
      expNamePlaceholder: '请输入文件名',
      expType: '文件类型',
      expSheetName: '标题名',
      expSheetNamePlaceholder: '请输入标题名',
      expMode: '要导出的数据',
      expColumn: '选择字段',
      expCurrentColumn: '全部字段',
      expOpts: '参数设置',
      expHeaderTitle: '是否需要表头',
      expOptHeader: '表头',
      expTitleTitle: '是否需要标题',
      expOptTitle: '标题',
      expColgroupTitle: '是否需要分组',
      expOptColgroup: '分组表头',
      expOriginalTitle: '是否需要源数据',
      expOptOriginal: '源数据',
      expMergeTitle: '是否需要合并',
      expOptMerge: '合并',
      expUseStyleTitle: '是否需要样式',
      expOptUseStyle: '样式',
      expAllExpandTitle: '是否需要展开',
      expOptAllExpand: '展开层级',
      expFooterTitle: '是否需要表尾',
      expOptFooter: '表尾',
      expCancel: '取消',
      expConfirm: '导出',
      expPrint: '打印',
      modes: {
        current: '当前数据（当前页的数据）',
        selected: '选中数据',
        all: '全部数据',
        empty: '空数据',
        insertTop: '顶部追加',
        covering: '覆盖追加',
      },
      types: {
        csv: 'CSV (逗号分隔)(*.csv)',
        html: 'HTML (*.html)',
        xml: 'XML (*.xml)',
        txt: 'TXT (制表符分隔)(*.txt)',
        xlsx: 'Excel (*.xlsx)',
        pdf: 'PDF (*.pdf)',
      },
    },
    tour: {
      next: '下一步',
      previous: '上一步',
      finish: '结束导览',
    },
    tree: {
      emptyText: '暂无数据',
    },
    transfer: {
      noMatch: '无匹配数据',
      noData: '无数据',
      titles: ['列表 1', '列表 2'],
      filterPlaceholder: '请输入搜索内容',
      noCheckedFormat: '共 {total} 项',
      hasCheckedFormat: '已选 {checked}/{total} 项',
    },
    image: {
      error: '加载失败',
    },
    pageHeader: {
      title: '返回',
    },
    popconfirm: {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
    },
    formCreate: {
      submit: '提交',
      reset: '重置',
    },
    formDesigner: {},
    carousel: {
      leftArrow: '上一张幻灯片',
      rightArrow: '下一张幻灯片',
      indicator: '幻灯片切换至索引 {index}',
    },
  },
}
